import { TThunkAction } from '../../types/redux';
import { resetWidget } from '../../actions/common';
import { getResultCancel } from '../../utils/result';

export const closeModalThunk = (): TThunkAction => (dispatch, _, context) => {
  const { resolveWidgetResult } = context;

  dispatch(resetWidget());

  resolveWidgetResult(getResultCancel());
};
